import React from 'react'

import { ClickWrapAdditionalActionsComponent } from '../../../global/clickwrap/types'

function withAcceptedContentActions(
  contentActions: ClickWrapAdditionalActionsComponent,
): ClickWrapAdditionalActionsComponent {
  return function AcceptedContentActionsHOC(props) {
    return React.createElement(contentActions, {
      ...props,
      defaultChecked: true,
      disabled: false,
      onChanged: () => {
        // empty callback since agreement is already accepted
      },
      readonly: true,
    })
  }
}

export default withAcceptedContentActions
